import { spawn } from "node:child_process";
import { run } from "./exec.js";

/** Canonical public surfaces (Entry A = MCP URL, zero credentials). */
export const MCP_URL = "https://mcp.carrier.llc/mcp";
/** Carrier REST API, for the capabilities MCP does not expose. */
export const API_URL = "https://api.carrier.llc";
export const MCP_HOME = "https://mcp.carrier.llc";
export const SIGN_UP_URL = "https://accounts.carrier.llc/sign-up";
/**
 * Clerk Frontend API. Read-only from the CLI: `carrier signup` posts to
 * `apps/api`, which is the only place the sign-up rate limit can be enforced,
 * and reads `/v1/environment` here to learn whether consent must be collected.
 */
export const CLERK_FAPI_URL = "https://clerk.carrier.llc";
export const SIGN_IN_URL = "https://accounts.carrier.llc/sign-in";
export const CONSOLE_URL = "https://app.carrier.llc";
export const ONBOARDING_URL = "https://app.carrier.llc/onboarding";
export const BILLING_URL = "https://accounts.carrier.llc/user/billing";
export const DOCS_URL = "https://mcp.carrier.llc/docs";

/** Open a URL in the system browser (best-effort; never throws). */
export async function openUrl(url: string): Promise<{ ok: boolean; hint: string }> {
  const platform = process.platform;
  if (platform === "darwin") {
    const r = await run("open", [url]);
    return r.ok
      ? { ok: true, hint: `Opened ${url}` }
      : { ok: false, hint: `Could not open browser. Visit:\n  ${url}` };
  }
  if (platform === "win32") {
    // `start` is a shell builtin; use cmd.exe.
    const r = await run("cmd", ["/c", "start", "", url]);
    return r.ok
      ? { ok: true, hint: `Opened ${url}` }
      : { ok: false, hint: `Could not open browser. Visit:\n  ${url}` };
  }
  // Linux / other: try xdg-open, then free-desktop `open`.
  for (const bin of ["xdg-open", "open"]) {
    const r = await run(bin, [url]);
    if (r.ok) return { ok: true, hint: `Opened ${url}` };
  }
  // Last resort: detach spawn without waiting (some WSL setups hang).
  try {
    spawn("xdg-open", [url], { detached: true, stdio: "ignore" }).unref();
    return { ok: true, hint: `Launched browser for ${url}` };
  } catch {
    return { ok: false, hint: `Could not open browser. Visit:\n  ${url}` };
  }
}
